module.exports = __webpack_public_path__ + "static/media/icon_check_blue.daa01229.svg";